<template>
    <header id="introduction" class="section_intro">
        <div class="grid-container">
            <div class="grid-x align-center">
                <section class="cell small-12 medium-10">
                    <h2 class="section_intro--title">Introduction</h2>
                    <p class="section_intro--subtitle">Ryusuke Hamaguchi Early Works</p>
                    <p class="text">商業映画デビュー作『寝ても覚めても』がカンヌ国際映画祭コンペティション部門出品という快挙を成し遂げるなど、世界が注目する濱口竜介監督。いまを生きる人々の姿を、そして人々が生きる街を、鮮烈な映像表現で描き続ける濱口作品は、これから益々世界中で観られるようになるのは間違いない。『天国はまだ遠い』までの作品を、あえてアーリー・ワークス（初期作品群）と銘打ち、『寝ても覚めても』以降の作品群を観る前の予習・復習の機会として特集上映を開催する。</p>
                </section>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: 'introduction',
    data () {
        return {
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Introduction.vue